<app-modal-header-common title="Subscribed OKRs" [dialogRef]="dialogRef"> </app-modal-header-common>
<div class="okr-dialog">
  <div class="content">
    <app-okr-listing
      [OKRList]="okrData"
      [currentObjective]="currentObjective"
      [showMonths]="true"
    ></app-okr-listing>
  </div>
  <div style="display: flex; justify-content: end" class="modal-footer mt-4">
    <button (click)="closeDialog()" mat-button color="secondary">
      Close
    </button>
  </div>
</div>
